import { initERM } from '@adornis/entity-relationship-management/init.js';
import '@nsc/smartteams-shared/api/index.js';
import './app-access.js';
import './create-customer-with-user.js';
import './create-field-engineer-with-user.js';
import './create-user-for-field-engineer.js';
import './course-enrollment-page.js';
import './customer-user-assignments.js';
import './export-field-engineers-csv.js';
import './import-field-engineers-csv.js';
import './migrate-field-engineer-email.js';
import './scoped-queries.js';
import './send-customer-onboarding-email.js';
import './send-field-engineer-onboarding-email.js';
import './soft-delete.js';
import './servicenow-lookups.js';
import './sync-company-field-engineers.js';

initERM({
  policies: [
    {
      name: '@nsc/smartteam/erm',
      evaluate: async () => ({ allowed: true, reason: '-' }),
    },
  ],
});
